const css = require('./actions-panel.css');
const { cut } = require('../../../../../helpers/utils');
let signals = require('../../../../../signals/account/user-form');
const bitrix = require('../../../../../signals/bitrix');

const SAVE_BUTTON_SELECTOR = cut(css.saveButton);
const CANCEL_BUTTON_SELECTOR = cut(css.cancelButton);

class ActionsPanel {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.$context.signal(bitrix.resize);
        return {
            click: {
                [SAVE_BUTTON_SELECTOR]: this.save,
                [CANCEL_BUTTON_SELECTOR]: this.cancel
            }
        };
    }

    save () {
        this.$context.signal(signals.onSaveUserInfoChange);
    }

    cancel () {
        this.$context.signal(signals.onCancelUserInfoChange);
    }
}

module.exports = {
    constructor: ActionsPanel
};



// WEBPACK FOOTER //
// ./components/common/user/user-form/actions-panel/index.js